import React from "react";
import { ReactComponent as MessageSvg } from "../../assets/icons/message.svg";

export default function MessageIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <MessageSvg
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
      }}
    />
  );
}
